import { Button, Modal } from "antd";
import { useEffect, useRef, useState } from "react";
import WebUtils from "../../utils/WebUtils";
import { endInterviewApi } from "../../../api";
import Icon from "../../../assets/Icon";

const END_TIMER = 60;

function InactivityDisqualifyModal({
  voiceInactiveWarningModal,
  interviewData,
  setLoading,
  videoBlobQueueRef,
  screenShareBlobQueueRef,
  timeRemainingRef,
  chatMessagesRef,
  ip,
  stopRecording,
  resumeInterviewHandler,
  allowUnloadRef
}) {
  const [logCode, setLogCode] = useState(
    "End interview finished with voice inactivity dectect"
  );
  const [logMessage, setLogMessage] = useState(
    "Candidate is not speaking and has exceeded their time limit"
  );
  const [secondsRemaining, setSecondsRemaining] = useState(END_TIMER || 60);
  const endInterviewFlag = useRef(false);
  const endIntervalRef = useRef(null);
  const countdownIntervalRef = useRef(null);

  const endInterviewFunc = () => {
    setLoading(true);
    if (
      videoBlobQueueRef.current.length === 0 &&
      screenShareBlobQueueRef.current.length === 0 &&
      endInterviewFlag.current
    ) {
      setLoading(false);
      clearInterval(endIntervalRef.current);
      allowUnloadRef.current = true
      window.location.href = `/interview-completed?interviewId=${interviewData?.interviewId}`;
      return;
    }
  };
  let logs = WebUtils.logData();
  const callEndInterviewApi = () => {
    let url = endInterviewApi;

    let browserData = navigator;
    const logBody = {
      ...logs,
      role: interviewData?.userRole,
      name: interviewData?.name,
      ipAddress: ip,
      logCode: logCode,
      logMessage: logMessage,
    };

    const requestBody = {
      interviewId: interviewData?.interviewId,
      ipLog: logBody,
      interviewType: interviewData?.interviewType,
      timeLeft: timeRemainingRef.current,
      interviewConversation: chatMessagesRef.current,
    };

    WebUtils.httpOperations(url, requestBody, "POST")
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
        }
        endInterviewFlag.current = true;
      })
      .catch((err) => {
        endInterviewFlag.current = true;
        console.log(err);
      });
  };

  useEffect(() => {
    const intervalDuration = 1000; // 1 second

    countdownIntervalRef.current = setInterval(() => {
      setSecondsRemaining((prev) => {
        if (prev <= 0) {
          clearInterval(countdownIntervalRef.current);
          stopRecording();
          endIntervalRef.current = setInterval(endInterviewFunc, 500);
          callEndInterviewApi();
          return 0;
        }
        return prev - 1;
      });
    }, intervalDuration);

    return () => clearInterval(countdownIntervalRef.current);
  }, []);

  return (
    <Modal
      className="rejoin-modal"
      open={voiceInactiveWarningModal}
      closable={false}
      maskClosable={false}
      keyboard={false}
      centered
      footer={null}
      width={480}
    >
      <div className="flex gap-2 items-center">
        <Icon type="warning-icon" width="45" height="45" />
        <div className="text-lg font-semibold">Voice Inactivity Detected</div>
      </div>
      <p className="mt-4 text-[.9rem] text-[#475467]">
        You have not spoken for 3 minutes. Your interview will be marked as
        completed and automatically concluded if you do not resume speaking
        within the next{" "}
        <span className="font-bold text-black">{END_TIMER} seconds.</span>
      </p>
      <div className="text-base mt-4 text-center w-full">
        Your interview will end in...{" "}
        <p className="w-[60px] inline-block font-bold ">
          {" "}
          {secondsRemaining} sec.
        </p>
      </div>
      <div className="text-[.95rem] flex flex-col md:flex-row gap-[.5rem] justify-center mt-5 items-center">
        <Button
          className="w-full md:w-[49%] py-[1.1rem]"
          type="primary"
          onClick={resumeInterviewHandler}
        >
          Resume Interview
        </Button>
        <Button
          type="primary"
          danger
          className="flex-1 py-[1.1rem]"
          onClick={() => {
            clearInterval(countdownIntervalRef.current);
            stopRecording();
            callEndInterviewApi();
            endIntervalRef.current = setInterval(endInterviewFunc, 500);
          }}
        >
          End Inteview
        </Button>
      </div>
    </Modal>
  );
}

export default InactivityDisqualifyModal;
